import classnames from 'classnames'
import {Map} from 'immutable'
import {memo} from 'react'
import PropTypes from 'prop-types'

import AddResponseGroup from './AddResponseGroup'
import ItemDetailsNoResponseGroups from './ItemDetailsNoResponseGroups'

import {FUNERAL_PREFERENCES_ITEM_SLUG} from '../../../../../lib/deputyPermissionTools'

import './itemHeader.scss'

const ItemHeader = props => {
  const suppressAddResponseGroup = props.isFuneralHome &&
    props.itemResponse.get('slug') === FUNERAL_PREFERENCES_ITEM_SLUG &&
    !props.itemResponse.get('response-groups').isEmpty()

  return (
    <header
      className={classnames('item-header flex-container',
        {empty: props.itemResponse.get('response-groups').isEmpty()})}>
      <h3 className='flex-child'>{props.itemResponse.get('header')}</h3>
      {
        props.hasEditPermission && !suppressAddResponseGroup ?
          <AddResponseGroup {...props} /> :
          <ItemDetailsNoResponseGroups {...props} />
      }
    </header>
  )
}

ItemHeader.propTypes = {
  hasEditPermission: PropTypes.bool,
  isFuneralHome: PropTypes.bool,
  itemResponse: PropTypes.instanceOf(Map)
}

const areEqual = (prevProps, nextProps) => (
  prevProps.everplanSummary.equals(nextProps.everplanSummary) &&
  prevProps.itemResponse.equals(nextProps.itemResponse) &&
  prevProps.isFuneralHome === nextProps.isFuneralHome &&
  prevProps.hasEditPermission === nextProps.hasEditPermission
)

export default memo(ItemHeader, areEqual)
